import React, { FC } from "react";
import { Icon } from "assets/icons";
import classNames from "classnames";

interface AccordionParentProps {
  name: string;
  collapsed: boolean;
  iconClassNames?: string;
  disabled?: boolean;
}

export const AccordionParent: FC<AccordionParentProps> = ({
  name,
  collapsed,
  iconClassNames,
  disabled,
}) => (
  <div
    className={classNames(
      "bg-purple-100 py-1.5 px-4 rounded-lg",
      !disabled &&
        "cursor-pointer transition-colors duration-300 ease-in-out hover:bg-purple-400 hover:text-white"
    )}
  >
    <div
      className={classNames(
        "absolute right-1 top-2.5",
        !disabled && "cursor-pointer"
      )}
    >
      {collapsed ? (
        <Icon
          type="arrow"
          className={`rotate-90 transition-transform ${iconClassNames}`}
        />
      ) : (
        <Icon
          type="arrow"
          className={`rotate-180 transition-transform ${iconClassNames}`}
        />
      )}
    </div>
    {name}
  </div>
);
